/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProductVariantEnum = 'Html' | 'PdfUndSonstigesFormat' | 'Jpg' | 'StandardlayoutFuerFliesstextanzeigen' | 'Standardlayout' | 'StandardHtml';

export const ProductVariantEnum = {
    Html: 'Html' as ProductVariantEnum,
    PdfUndSonstigesFormat: 'PdfUndSonstigesFormat' as ProductVariantEnum,
    Jpg: 'Jpg' as ProductVariantEnum,
    StandardlayoutFuerFliesstextanzeigen: 'StandardlayoutFuerFliesstextanzeigen' as ProductVariantEnum,
    Standardlayout: 'Standardlayout' as ProductVariantEnum,
    StandardHtml: 'StandardHtml' as ProductVariantEnum
};

